import React, { PropTypes } from 'react';
import { secureLoadingImageUrl } from 'constants';
import { getImageUrlWithParams } from 'lib/url-adapter';

const COMPRESSION_RATE = 40;

/**
 * Generates a single srcSet entry
 * @param {string} url
 * @param {number} width
 */
function getSrcSetEntry(url, width) {
    return `${url} ${width}w`;
}

/**
 * Take an image url and returns full srcSet value
 * @param {string} url - Either an artwork or CDN url
 * @return {array} - array of size numbers
 */
function getSrcSet(url, cquality, sizes = []) {
    return sizes.map((width) => {
        const sizedUrl = getImageUrlWithParams(url, { cquality, width });
        return getSrcSetEntry(sizedUrl, width);
    }).reduce((acc, srcSetEntry) => `${srcSetEntry}, ${acc}`);
}

const ResponsiveThumbnail = ({
    alt,
    className,
    style,
    lazyload,
    srcSetWidths,
    src: srcProp,
    sizes,
    cquality
}) => {
    if (!srcProp) {
        return null;
    }
    // compress combiner urls
    const src = getImageUrlWithParams(srcProp, { cquality });
    const srcSet = (srcSetWidths.length > 0) ? getSrcSet(srcProp, cquality, srcSetWidths) : null;

    let imgProps = {
        src,
        srcSet,
        className,
        style
    };

    if (lazyload) {
        imgProps = {
            src: secureLoadingImageUrl,
            'data-src': src,
            'data-srcset': srcSet,
            className: `${className} lazyload`
        };
    }

    return (
        <picture>
            <img {...imgProps} sizes={sizes} alt={alt} />
        </picture>
    );
};

ResponsiveThumbnail.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    src: PropTypes.string,
    srcSetWidths: PropTypes.array,
    sizes: PropTypes.string,
    lazyload: PropTypes.bool,
    cquality: PropTypes.number
};

ResponsiveThumbnail.defaultProps = {
    src: '',
    srcSetWidths: [],
    sizes: '25vw',
    className: 'media-wrapper_image',
    lazyload: false,
    cquality: COMPRESSION_RATE
};

export default ResponsiveThumbnail;



// WEBPACK FOOTER //
// ./app/common/ResponsiveThumbnail.js